"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../material/index");

var _categoryselector = _interopRequireDefault(require("./categoryselector/categoryselector"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _searchbar_styles = _interopRequireDefault(require("./searchbar_styles"));

var _searchbar_definition = _interopRequireDefault(require("./searchbar_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
//material
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : SEARCH BAR ~~~~~~~~~~ ========== */


var SearchBar = (0, _reactJss.default)(_searchbar_styles.default)(function (props) {
  return _react.default.createElement("div", {
    className: "searchbar ".concat(props.classes.searchbar, " categories-").concat(!!props.categories)
  }, props.categories && _react.default.createElement(_categoryselector.default, {
    selectCategory: props.selectCategory,
    currentCategory: props.currentCategory,
    categories: props.categories
  }), _react.default.createElement("div", {
    className: 'search'
  }, _react.default.createElement(_index.Icon, {
    name: "search"
  }), _react.default.createElement("span", {
    className: "field"
  }, _react.default.createElement("input", {
    type: props.type,
    name: props.name,
    placeholder: props.placeholder,
    onFocus: props.handleFocus,
    onBlur: props.handleBlur,
    onChange: function onChange(e) {
      return props.onChange(e.target.value);
    },
    onKeyDown: props.onKeyDown,
    value: props.value
  }))));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(SearchBar, _searchbar_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = SearchBar;
exports.default = _default;